<div class="page">
  <nav aria-label="Breadcrumb">
    <ol class="crumbs">
      <li><a uiSref="discussion">Forums</a></li>
      @if (discussion.category) {
        <li><ut-category-link [category]="discussion.category" [plain]="true"></ut-category-link></li>
      }
      <li><span aria-current="page" [innerHTML]="title | emojiHtml"></span></li>
    </ol>
  </nav>

  <div class="topic__main">
    <article class="card topic">
      <header class="topic__head">
        <!-- As on the topic list: avatar, name and date first, then the title and its category. -->
        <span class="byline">
          @if (discussion.user?.slug) {
            <a class="byline__author" uiSref="profile.about" [uiParams]="{ profileId: discussion.user.slug }">
              <ut-avatar-badges class="byline__avatar" [user]="discussion.user" aria-hidden="true"></ut-avatar-badges>
              <span class="byline__name">{{ discussion.user.name }}</span>
            </a>
          } @else {
            <span class="byline__author">
              <ut-avatar-badges class="byline__avatar" [user]="discussion.user" aria-hidden="true"></ut-avatar-badges>
              <span class="byline__name">{{ discussion.user?.name }}</span>
            </span>
          }
          <span class="byline__when">
            @if (authorMeta) {
              {{ authorMeta }} <span aria-hidden="true">&middot;</span>&ngsp;
            }
            <time [attr.datetime]="discussion.published_at" [title]="discussion.published_at | date: 'MMM d, y, h:mm a'">{{ discussion.published_at | relativeDate }}</time>
          </span>
        </span>
        <h1 class="topic__title" [innerHTML]="title | emojiHtml"></h1>
        <div class="topic__chips">
          @if (discussion.category) {
            <ut-category-link [category]="discussion.category"></ut-category-link>
          }
          @if (discussion.locked) {
            <span class="badge"><span class="material-icons" aria-hidden="true">lock</span>Locked</span>
          }
          @if (discussion.state === 'hidden') {
            <span class="badge badge--error"><span class="material-icons" aria-hidden="true">visibility_off</span>Hidden</span>
          }
        </div>
      </header>
      <!-- Toolbar above the post, as on the legacy page (FORUM_POST_OPTIONS.html, option A). -->
      <ut-item-actions
        class="topic__toolbar"
        [item]="discussion"
        [user]="user"
        [shareUrl]="shareUrl"
        [showCommentCount]="false"
        (stateChanged)="refresh()">
        @if (canManage) {
          <button type="button" itemActionsEnd class="ut-btn ut-btn--secondary ut-btn--sm topic__manage" aria-label="Manage topic" [cdkMenuTriggerFor]="manageMenu">
            <span class="material-icons" aria-hidden="true">more_horiz</span>
          </button>
        }
      </ut-item-actions>
      <!-- Outside ut-item-actions so the menu template isn't content-projected. -->
      <ng-template #manageMenu>
        <div class="menu" cdkMenu>
          @if (discussion.current_user_permissions?.destroy) {
            <a class="menu__item" cdkMenuItem uiSref="editDiscussion" [uiParams]="{ discussionId: discussion.id }">
              <span class="material-icons" aria-hidden="true">edit</span>Edit topic
            </a>
          }
          @if (discussion.current_user_permissions?.lock) {
            <button type="button" class="menu__item" cdkMenuItem (cdkMenuItemTriggered)="toggleLock()">
              <span class="material-icons" aria-hidden="true">{{ discussion.locked ? 'lock_open' : 'lock' }}</span>
              {{ discussion.locked ? 'Unlock replies' : 'Lock replies' }}
            </button>
          }
          @if (discussion.current_user_permissions?.destroy) {
            <button type="button" class="menu__item menu__item--danger" cdkMenuItem (cdkMenuItemTriggered)="confirmDelete()">
              <span class="material-icons" aria-hidden="true">delete_outline</span>Delete topic
            </button>
          }
        </div>
      </ng-template>
      <div class="prose topic__body" [innerHTML]="body"></div>
    </article>

    @if (discussion.locked) {
      <div class="alert alert--info" role="status">
        <span class="material-icons" aria-hidden="true">lock</span>
        <p class="alert__text">Replies are locked.</p>
      </div>
    }
    <ut-comment-thread class="card" [service]="DiscussionService" [commentable]="discussion" [user]="user" [locked]="discussion.locked" composeLabel="Add a reply" (totalChange)="threadCount.set($event)"></ut-comment-thread>
  </div>
</div>
